<div class="text-left" *ngIf="product" class="product-information-box">
    <!--    <h3 style="color: #323232;    margin-bottom: 2px;">{{product.name}}</h3>-->

    <div style="background-color: white;
    padding: 30px;
    border-radius: 10px;
    border: 2px solid #35c7c7;">
        <div class="">
            <div style="margin-bottom:5px;color:#888; "><span style="    color: #36c7c7;
    font-weight: 700;">Serial: </span> {{product.sku}}</div>
            <div class="">
                <div class="product-details-price ">
                    <div>
                        <span *ngIf="!hasSpecialPrice" style="color:#454545; font-size: 18px "
                              class="product-price"> {{current_currency}}
                            <label style="font-weight: 700;">{{this.price | number:this.registry.getSettingByID('price_format')}} </label>   </span>
                        <span *ngIf="hasSpecialPrice" class="product-price"
                              style="color:red; font-weight: bold; font-size: 18px "> {{current_currency}} {{this.getSpecialPrice() | number:this.registry.getSettingByID('price_format')}}    </span>
                        <span *ngIf="hasSpecialPrice" class="product-price"
                              style="color: grey;text-decoration-line: line-through; font-size: 16px ; font-weight: 300;margin-left: 10px; "> {{current_currency}} {{this.price | number : this.registry.getSettingByID('price_format')}} </span>
                    </div>
                    <!--                <span class="product-price">{{env.defaultCurrency}} {{product.price  | number:'.3'}}</span>-->
                </div>
            </div>
            <div class="">
                <div class="d-flex mt-3">
                    <label class="flex-grow-1" style="    color: #36c7c7;
    font-weight: 700;
    font-size: 17px;" i18n="@@availability">Availability</label><br>
                    <span class="badge badge-success" style="    font-size: 15px;background-color: #36c7c7;"
                          *ngIf="product.inStock()" i18n>In Stock</span><span
                        class="badge badge-danger" style="    font-size: 15px;" *ngIf="!product.inStock()" i18n>Out of Stock</span>
                </div>
            </div>


        </div>


        <div class="pt-3">

            <div *ngIf="product.inStock()">
                <div i18n>Quantity</div>
                <div class="component-cont">

                    <input [min]="1"
                           style="   width: 58px;border: 1px solid #f0f0f0;border-radius: 5px; outline: none !important;"
                           type="number" [ngModel]="qty" (ngModelChange)="newValue($event)"/>
                </div>

            </div>
        </div>

        <div>
            <app-product-options *ngIf="configurableProductOptions.length > 0"
                                 [productOptions]="configurableProductOptions"></app-product-options>
        </div>
    </div>

    <div class="buttons">
        <div class="addToCartButton d-flex">
            <button [disabled]="isAdding || !product.inStock()" class="btn btn-primary btn-block mr-md-1"
                    style="padding: 8px 50px; margin-top: 20px ;background-color: #146172;" (click)="addItemToCart()">

                <table width="100%">
                    <tr>
                        <td><img *ngIf="isAdding" src="assets/loader.gif" width="15" style="width: 15px;"/></td>
                        <td><span *ngIf="!isAdding && product.inStock()" i18n>    ADD TO CART</span>
                            <span *ngIf="isAdding && product.inStock()" i18n>   ADDING PRODUCT...</span>
                            <span *ngIf="!product.inStock()" i18n>   Out of stock</span>
                        </td>
                    </tr>

                </table>
            </button>
            <a style="padding: 8px 50px; margin-top: 20px ;background-color: #35c7c7;" class="btn btn-primary btn-block"
               *ngIf="!isProductInWishlist && this.registry.customer!=undefined" href="#"
               (click)="addItemToWishlist($event)" i18n><i class="la la-heart"></i> Add to wishlist</a>
        </div>

    </div>
    <div class="row pt-3">
        <div class="col-md-12">

            <a style="cursor: pointer;" *ngIf="isProductInWishlist && this.registry.customer!=undefined"
               (click)="deleteItemFromWishlist($event)" i18n><i class="la la-heart " style="color:red; "></i> This item
                is in my Wishlist!</a>
        </div>
        <!--        <div class="col-md-3"><i class="fa fa-bar-chart" i18n></i> Compare</div>-->
    </div>
    <br>
    <mat-divider>
    </mat-divider>
    <!--    <share-buttons theme="material-dark" show="11" image="https://loremflickr.com/320/240"></share-buttons>-->
    <!--    <share-button socialMedia="facebook" [url]="''" [title]="'title'" [description]="'description'"></share-button>-->
    <!--    <a href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="twitter-share-button" data-show-count="false">Tweet</a><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>-->

    <div class="d-flex">
        <div class="d-flex flex-sm-grow-1">

            <span class="mr-3" i18n="@@share_on">
                Share on
            </span>

            <share-buttons
                    class="flex-sm-grow-1"
                    [url]="productUrl"
                    [title]="productTitle"
                    [description]="productDescription"
                    [image]="productImage"
                    [theme]="'default'"
                    [include]="['facebook', 'twitter' ,'linkedin','pinterest','whatsapp']"
                    [autoSetMeta]="false"
            >

            </share-buttons>
        </div>

        <div>
            <div i18n="@@product_rating">Product rating</div>
            <div class="d-flex" style="color: #999;">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
            </div>
        </div>
    </div>


</div>

